// (function () {
//     'use strict';

//     angular.module("imApp").factory("businesscoOnBoardingService", ['$ihttp', function ($ihttp) {
//         let service = {
//             getEdit: function (parms) {
//                 return $ihttp.post({
//                     method: 3250,
//                     parameters: parms || {}
//                 });
//             },
//             saveObj: function (edit) {
//                 return $ihttp.post({
//                     method: 3251,
//                     parameters: edit
//                 });
//             }
//         };

//         return service;
//     }]);
// })();
